import { render, staticRenderFns } from "./CustomerOriginForm.vue?vue&type=template&id=2e5c8a9e&"
import script from "./CustomerOriginForm.vue?vue&type=script&lang=js&"
export * from "./CustomerOriginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports